import React from 'react';
import PropTypes from 'prop-types';
import WMMenuItem from '@workmarket/front-end-components/dist/WMMenuItem';
import styles from './styles';

const DefaultChatMenu = ({ support, useZendesk }) => (
	<React.Fragment>
		<WMMenuItem
			className="app-social-menu-help-center"
			href="https://workmarket.zendesk.com/hc/en-us"
			target="_blank"
			primaryText="Help Center"
			style={ styles.item }
		/>
		<WMMenuItem
			className="app-social-menu-support-email"
			href={ support.emailHref }
			primaryText={ support.emailText }
			style={ styles.item }
		/>
		{
			!!useZendesk &&
			<WMMenuItem
				className="app-social-menu-chat"
				onClick={ () => {
					window.zE('webWidget', 'show'); // eslint-disable-line no-undef
					window.zE('webWidget', 'open'); // eslint-disable-line no-undef
				} }
				primaryText="Chat with us"
				style={ styles.item }
			/>
		}
		<WMMenuItem
			className="app-social-menu-phone"
			href={ support.phoneHref }
			primaryText={ support.phoneText }
			style={ styles.item }
		/>
		<WMMenuItem
			className="app-social-menu-status-page"
			href="https://status.workmarket.com"
			primaryText="Status Page"
			style={ styles.item }
		/>
	</React.Fragment>
);

DefaultChatMenu.propTypes = {
	support: PropTypes.object, // eslint-disable-line react/forbid-prop-types
	useZendesk: PropTypes.bool
};

DefaultChatMenu.defaultProps = {
	support: {},
	useZendesk: false
};

export default DefaultChatMenu;



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/mainNav/components/SocialChatMenu/DefaultChatMenu.jsx